import React, { useState } from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import TrustPilotImage from 'Containers/app/fastlane/TrustPilotImage/TrustPilotImage';
import { Content } from 'LegacySBCRA/Content/Content';

import { CheckerPageType } from '../../Pages/CheckerPage/CheckerPage';
import LocalTexts from '../../texts.json';

import { CheckerForm } from './SubComponents/CheckerForm/CheckerForm';
import { HeroImageCard } from './SubComponents/HeroImageCard/HeroImageCard';
import { HeroVehicleImage } from './SubComponents/HeroVehicleImage/HeroVehicleImage';

import styles from './CheckerHero.scss';

const LocalT = new MDText(LocalTexts);

const translate = (key: string, args?: Record<string, React.ReactNode>) => LocalT.translate(key, args);

type CheckerHeroProps ={
  checkerPage?: CheckerPageType;
  description: string;
  title: string;
}

export const CheckerHero = ({ checkerPage, description, title }: CheckerHeroProps) => {
  const [imageLoaded, setImageLoaded] = useState<boolean>(false);

  const isMotCheck = checkerPage === 'motCheck';

  const checker = isMotCheck ? 'MOT' : 'Tax';

  return (
    <div className={styles.component}>
      <Content className={styles.heroContentWrapper}>
        <main className={styles.heroWrapper}>
          <div className={styles.heroInnerWrapper}>
            <section className={styles.heroVRM}>
              <span className={styles.eyebrow}>{isMotCheck ? 'MOT Checker' : 'Tax Checker'}</span>
              <h1 className={styles.heading}>
                {title || translate('hero.title.headline', { checker })}
              </h1>
              <p className={styles.strap}>
                {description || translate('hero.title.description', { checker })}
              </p>
              <CheckerForm {...{ isMotCheck }} />
              <TrustPilotImage className={styles.trustpilot} />
            </section>
          </div>
          <section className={styles.imageContainer}>
            <div className={cx(styles.car, {
              [styles.imageLoaded]: imageLoaded,
            })}>
              <HeroImageCard {...{ isMotCheck }} />
              <HeroVehicleImage {...{ setImageLoaded }} />
            </div>
          </section>
        </main>
      </Content>
    </div>
  );
};
